// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"eb155083","732":"76ebde8e","977":"2ff8d1c0"}[chunkId] + ".chunk.js";
};